export interface Section {
  heading: string;
  paragraphs: string[];
}

const content: Section[] = [
  {
    heading: "Chính sách quyền riêng tư của VF Money",
    paragraphs: [
      'VF Money ("chúng tôi") cung cấp dịch vụ cho vay kỹ thuật số dành cho người dùng tại Việt Nam. Chúng tôi cam kết bảo vệ thông tin cá nhân của bạn và xử lý dữ liệu một cách minh bạch, an toàn, tuân thủ các quy định pháp luật hiện hành cũng như yêu cầu về quyền riêng tư của Google Play.',

      'Chính sách quyền riêng tư này giải thích các loại thông tin mà VF Money thu thập, mục đích thu thập, cách chúng tôi sử dụng, lưu trữ và bảo vệ thông tin của bạn khi bạn sử dụng ứng dụng VF Money ("Ứng dụng").',

      "Bằng việc cài đặt hoặc sử dụng Ứng dụng, bạn xác nhận rằng bạn đã đọc, hiểu và đồng ý với các điều khoản trong Chính sách quyền riêng tư này.",
    ],
  },
  {
    heading: "1. Thông tin chúng tôi thu thập",
    paragraphs: [
      "Để cung cấp dịch vụ vay an toàn, nhanh chóng và phù hợp với nhu cầu của bạn, VF Money có thể thu thập và xử lý một số thông tin nhất định khi có sự đồng ý của bạn.",

      "A. Thông tin bạn cung cấp",
      "Trong quá trình đăng ký tài khoản hoặc đăng ký khoản vay, bạn có thể được yêu cầu cung cấp các thông tin bao gồm:",
      "Họ và tên, giới tính, ngày sinh",
      "Thông tin nhận dạng cá nhân (ví dụ: CCCD hoặc giấy tờ tùy thân tương đương)",
      "Số điện thoại, email và địa chỉ cư trú",
      "Thông tin nghề nghiệp, thu nhập và trình độ học vấn",
      "Thông tin người liên hệ khẩn cấp (họ tên, số điện thoại, mối quan hệ)",
      "Thông tin tài khoản ngân hàng hoặc ví điện tử được sử dụng để nhận khoản vay hoặc thanh toán khoản vay",

      "B. Thông tin thiết bị",
      "Nhằm đảm bảo an toàn hệ thống, cải thiện trải nghiệm và phòng chống gian lận, chúng tôi có thể thu thập một số thông tin kỹ thuật của thiết bị như:",
      "Loại thiết bị, phiên bản hệ điều hành, nhà sản xuất thiết bị",
      "Dung lượng RAM và tình trạng bộ nhớ thiết bị",
      "Thông tin nhà mạng SIM (MCC/MNC, trạng thái chuyển vùng)",
      "Địa chỉ IP, loại kết nối mạng, trạng thái Wi-Fi",
      "Mã nhận dạng thiết bị không cố định như Android SSAID",
      "ID quảng cáo Google phục vụ mục đích phân tích hoặc quảng cáo không cá nhân hóa",

      "C. Thông tin SMS liên quan đến tài chính",
      "Khi bạn cấp quyền truy cập, Ứng dụng có thể đọc các tin nhắn SMS chứa thông tin giao dịch tài chính từ ngân hàng, tổ chức thanh toán hoặc dịch vụ ví điện tử.",
      "Thông tin này được sử dụng nhằm:",
      "Hỗ trợ đánh giá khả năng tài chính",
      "Xác minh thông tin giao dịch",
      "Phát hiện và ngăn chặn hành vi gian lận",
      "Chúng tôi không đọc, thu thập hoặc lưu trữ các tin nhắn cá nhân không liên quan đến tài chính.",

      "D. Thông tin liên hệ khẩn cấp",
      "Bạn có thể chủ động cung cấp thông tin của người liên hệ khẩn cấp.",
      "VF Money chỉ sử dụng thông tin người liên hệ mà bạn tự nguyện cung cấp để phục vụ mục đích xác minh thông tin và đánh giá rủi ro. Chúng tôi không truy cập hoặc thu thập toàn bộ danh bạ trên thiết bị của bạn.",

      "E. Thông tin ứng dụng trên thiết bị",
      "Chúng tôi có thể thu thập một số thông tin cơ bản về các ứng dụng được cài đặt trên thiết bị (ví dụ: tên ứng dụng, mã gói ứng dụng).",
      "Thông tin này chỉ được sử dụng để:",
      "Phát hiện dấu hiệu bất thường hoặc gian lận",
      "Đảm bảo tính an toàn của thiết bị",
      "Chúng tôi không truy cập nội dung hoặc dữ liệu bên trong các ứng dụng đó.",

      "F. Quyền truy cập camera",
      "Ứng dụng có thể yêu cầu quyền truy cập camera để bạn chụp và tải lên:",
      "Hình ảnh giấy tờ tùy thân",
      "Hình ảnh xác minh danh tính",
      "Các tài liệu cần thiết khác",
      "Hình ảnh chỉ được sử dụng cho mục đích xác thực danh tính và đánh giá hồ sơ vay, không được chia sẻ cho bên thứ ba khi chưa có sự đồng ý của bạn, trừ trường hợp pháp luật yêu cầu.",

      "G. Vị trí gần đúng",
      "Thông tin vị trí gần đúng được xác định thông qua địa chỉ IP hoặc thông tin mạng có thể được sử dụng để:",
      "Xác minh tính hợp lệ của người dùng",
      "Phòng chống gian lận",
      "Cung cấp dịch vụ phù hợp theo khu vực",
      "Quyền truy cập vị trí chỉ được sử dụng khi Ứng dụng đang hoạt động.",

      "H. Nhật ký cuộc gọi",
      "Ứng dụng có thể yêu cầu quyền truy cập nhật ký cuộc gọi nhằm hỗ trợ quá trình đăng ký và xác thực tài khoản.",
      "Trong quá trình đăng ký hoặc đăng nhập, hệ thống có thể thực hiện cuộc gọi xác minh tự động đến số điện thoại bạn đã đăng ký. Ứng dụng có thể kiểm tra một số thông tin nhật ký cuộc gọi gần đây (ví dụ: số điện thoại, thời gian gọi, trạng thái cuộc gọi) để xác nhận cuộc gọi xác minh đã được thực hiện thành công.",
      "Thông tin nhật ký cuộc gọi chỉ được sử dụng cho:",
      "Xác minh danh tính",
      "Xác thực tài khoản",
      "Hỗ trợ đăng nhập thuận tiện hơn",
      "Thông tin này không được sử dụng cho mục đích quảng cáo, tiếp thị, đánh giá tín dụng hoặc chia sẻ cho bên thứ ba vì mục đích thương mại.",
    ],
  },
  {
    heading: "2. Mục đích sử dụng thông tin",
    paragraphs: [
      "VF money sử dụng thông tin của bạn cho các mục đích hợp pháp bao gồm:",
      "Xác minh danh tính và bảo vệ tài khoản",
      "Đánh giá hồ sơ vay và khả năng thanh toán",
      "Xử lý đơn vay, giải ngân và thu hồi khoản vay",
      "Phát hiện, ngăn chặn gian lận và giảm thiểu rủi ro",
      "Cung cấp hỗ trợ khách hàng và thông báo liên quan đến dịch vụ",
      "Tuân thủ các quy định về phòng chống rửa tiền (AML) và nghĩa vụ pháp lý",
      "Cải thiện hiệu suất ứng dụng và trải nghiệm người dùng",
    ],
  },
  {
    heading: "3. Chia sẻ thông tin",
    paragraphs: [
      "VF money cam kết không bán, trao đổi hoặc sử dụng thông tin cá nhân của bạn cho mục đích thương mại trái phép.",

      "Thông tin có thể được chia sẻ trong các trường hợp:",

      "A. Đối tác dịch vụ",
      "Chúng tôi có thể hợp tác với các đơn vị cung cấp dịch vụ hỗ trợ như:",
      "Lưu trữ dữ liệu",
      "Xác minh danh tính",
      "Xử lý thanh toán",
      "Phân tích hệ thống",
      "Các đối tác này phải tuân thủ các yêu cầu nghiêm ngặt về bảo mật dữ liệu.",

      "B. Yêu cầu pháp lý",
      "Thông tin có thể được cung cấp cho cơ quan nhà nước, tòa án hoặc cơ quan quản lý có thẩm quyền khi có yêu cầu theo quy định pháp luật Việt Nam.",

      "C. Đối tác xác minh tín dụng",
      "Trong trường hợp cần thiết, một số thông tin có thể được chia sẻ với các đơn vị xác minh tín dụng hợp pháp nhằm hỗ trợ đánh giá tín dụng và phòng chống gian lận.",
    ],
  },
  {
    heading: "4. Bảo mật dữ liệu",
    paragraphs: [
      "Chúng tôi áp dụng các biện pháp bảo mật phù hợp để bảo vệ thông tin cá nhân của bạn, bao gồm:",
      "Mã hóa SSL",
      "Kết nối HTTPS an toàn",
      "Kiểm soát quyền truy cập dữ liệu nội bộ",
      "Kiểm tra và đánh giá bảo mật định kỳ",
      "Dữ liệu được lưu trữ trên hệ thống máy chủ bảo mật tại:",
      "www.vfmoney.net",
    ],
  },
  {
    heading: "5. Lưu trữ dữ liệu",
    paragraphs: [
      "Chúng tôi chỉ lưu giữ thông tin cá nhân trong khoảng thời gian cần thiết để:",
      "Cung cấp dịch vụ vay",
      "Tuân thủ nghĩa vụ pháp lý",
      "Giải quyết tranh chấp",
      "Phục vụ kiểm toán hoặc kiểm tra theo quy định",
      "Sau thời gian lưu giữ, dữ liệu sẽ được xóa hoặc ẩn danh theo quy định.",
    ],
  },
  {
    heading: "6. Quyền của bạn",
    paragraphs: [
      "Bạn có quyền:",
      "Yêu cầu xem và truy cập thông tin cá nhân",
      "Yêu cầu chỉnh sửa thông tin không chính xác",
      "Rút lại quyền truy cập dữ liệu (khi phù hợp)",
      "Yêu cầu xóa dữ liệu cá nhân theo quy định pháp luật",
      "Bạn có thể liên hệ với bộ phận hỗ trợ VF Money để thực hiện các quyền trên.",
    ],
  },
  {
    heading: "7. Xóa tài khoản",
    paragraphs: [
      "Nếu bạn muốn xóa tài khoản VF Money, bạn có thể gửi yêu cầu đến chúng tôi.",
      "Việc xóa tài khoản có thể được thực hiện sau khi tất cả nghĩa vụ vay còn lại đã được hoàn tất.",
      "Một số thông tin vẫn có thể được lưu giữ nếu pháp luật yêu cầu.",
    ],
  },
  {
    heading: "8. Chuyển dữ liệu quốc tế",
    paragraphs: [
      "Thông tin của bạn có thể được xử lý trên hệ thống máy chủ đặt ngoài lãnh thổ Việt Nam nhằm đảm bảo hiệu quả vận hành.",
      "Mọi hoạt động chuyển dữ liệu đều được thực hiện với các biện pháp bảo vệ phù hợp nhằm đảm bảo an toàn thông tin.",
    ],
  },
  {
    heading: "9. Cập nhật chính sách",
    paragraphs: [
      "VF Money có thể cập nhật Chính sách quyền riêng tư này theo thời gian nhằm đáp ứng quy định mới, cải thiện dịch vụ và tăng tính minh bạch.",
      "Các thay đổi quan trọng sẽ được thông báo thông qua Ứng dụng hoặc các phương thức liên hệ phù hợp.",
    ],
  },
  {
    heading: "10. Liên hệ",
    paragraphs: [
      "Nếu bạn có bất kỳ câu hỏi nào liên quan đến quyền riêng tư hoặc việc sử dụng dữ liệu tại VF Money, vui lòng liên hệ:",
      "Email: service@vfmoney.net",
    ],
  },
];

export default content;
